import {
  Button,
  Container,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import {TitledSection} from 'components/layouts/aside-layout';
import {FormikErrors, FormikHandlers, FormikValues} from 'formik';
import React, {FC, useState} from 'react';
import {TranslationKeys} from 'translations';

interface Props {
  onChange: FormikHandlers['handleChange'];
  values: FormikValues;
  errors:
    | FormikErrors<{
        name: string;
        email: string;
        phonenumber: string;
      }>
    | undefined;
  t: (term: TranslationKeys) => string;
  helperUpdateCustomer: () => void;
  isLoadingUpdate: boolean;
}

export const Credentials: FC<Props> = ({t, onChange, values, errors, helperUpdateCustomer, isLoadingUpdate}) => {
  const [isChangedForm, setIsChangedForm] = useState(isLoadingUpdate);

  const onChangeHelper = (value: any) => {
    setIsChangedForm(true);
    onChange(value);
  };

  const onUpdateCustomer = () => {
    helperUpdateCustomer();
    setIsChangedForm(false);
  };

  return (
    <TitledSection title={t('MY_DATA')}>
      <Container variant="white-block">
        <SimpleGrid columns={[1, 2]} spacing="30px">
          <FormControl isRequired isInvalid={!!errors?.name}>
            <FormLabel
              fontWeight={600}
              requiredIndicator={
                <Text as="span" ml="4px" color="red">
                  *
                </Text>
              }
            >
              {t('USER_NAME')}
            </FormLabel>
            <Input
              id="name"
              name="name"
              type="text"
              placeholder={t('USER_NAME_PLACEHOLDER')}
              mt="6px"
              onChange={onChangeHelper}
              value={values?.name}
            />
            <FormErrorMessage>{errors?.name}</FormErrorMessage>
          </FormControl>
          <Flex flexDirection="column">
            <FormControl isRequired isInvalid={!!errors?.email}>
              <FormLabel
                fontWeight={600}
                requiredIndicator={
                  <Text as="span" ml="4px" color="red">
                    *
                  </Text>
                }
              >
                Email
              </FormLabel>
              <Input
                id="email"
                name="email"
                type="email"
                placeholder={t('EMAIL_PLACEHOLDER')}
                mt="6px"
                onChange={onChangeHelper}
                value={values?.email}
              />
              <FormErrorMessage>{errors?.email}</FormErrorMessage>
            </FormControl>
            {isChangedForm && (
              <Button
                variant="primary"
                w="50%"
                alignSelf="flex-end"
                h="40px"
                mt="20px"
                onClick={onUpdateCustomer}
                isLoading={isLoadingUpdate}
              >
                {t('SAVE')}
              </Button>
            )}
          </Flex>
        </SimpleGrid>
      </Container>
    </TitledSection>
  );
};
